<template>
  <div>
    <button @click="redirectToLogin">Login with Genesys</button>
  </div>
</template>

<script setup lang="ts">

const redirectToLogin = () => {
  window.location.href = import.meta.env.VITE_AUTH_URL;
};


</script>

<style scoped>
button {
  padding: 10px 20px;
  font-size: 1em;
}
</style>
